import { RECEIVE_TOP_ENTITIES } from "../constants/actions-type";
import { mapTopEntitiesByDataElementId } from "../lib/topEntitiesUtils";

export const receiveTopEntities = sections => ({
  type: RECEIVE_TOP_ENTITIES,
  byDataElementId: mapTopEntitiesByDataElementId(sections),
});
